import { IGroupModel } from '@src/slide/domain/ui-model/element-modeles/Interface/group-model.interface';
import { getAllChildModels, getExcludeValues, mergeMultiItemValues } from '@src/slide/domain/ui-model/element-modeles/property/utils/merge-property';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import { Locks } from '@src/slide/domain/ui-model/element-modeles/property/lock/lock.interface';
import * as mobx from 'mobx';
import { IEditorAppServices } from '@src/slide/application/entry/toc/editor/base/base-editor-app-service.interface';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IMenuManager } from '@src/slide/application/service/menu-manager/menu-manager.interface';
import { getAllImage, getElementMenuValues } from './element-menu-values-getter';
import { FILL_KEY } from '@src/slide/domain/ui-model/element-modeles/property/fill/fill.interface';
import { setImageValue } from './element-menu-values-setter';
import { IPictureModel } from '@src/slide/domain/ui-model/element-modeles/Interface/picture-model.interface';

/**
 * 获取当前model所有的菜单属性对象
 * @param model
 */
export function getMenuValues(model: IGroupModel): { [key: string]: any } {
    // 聚合子元素的菜单值获取，有缓存优先读取缓存
    const mergeMenuValuesCache = getMenuManager()?.mergeMenuValuesCacheMap.get(model);
    if (mergeMenuValuesCache) {
        return mergeMenuValuesCache;
    }
    if (model.children?.length && model.isRootGroup) {
        const children = getAllChildModels(model, true);
        const valuesArray: Array<any> = [];
        mobx.transaction(() => {
            children?.forEach((child) => {
                const menuValues = getElementMenuValues(child);
                noMergeKey([FILL_KEY], menuValues);
                valuesArray.push(menuValues);
            });
        });
        const mergeValues = mergeMultiItemValues(valuesArray, getExcludeValues(children));
        // 设置组合最外层锁定纵横比属性
        if (mergeValues[ActionType.SIZE_ADJUST] || model.props[Locks.LOCKS]) {
            mergeValues[ActionType.SIZE_ADJUST] = model.getLock().getLockInfo();
        }
        const [imageModel] = getAllImage(model);
        if (imageModel) {
            setImageValue(mergeValues, imageModel as IPictureModel);
        }
        mergeValues[FILL_KEY] = model.getBackgroundFill().getFillInfo() ?? undefined;
        return mergeValues;
    }
    return {};
}

/**
 * 组合部分属性无需合并子元素，直接取自身属性即可。
 */
function noMergeKey(keys: string[], menuValues) {
    keys.forEach((key) => {
        delete menuValues[key];
    });
}

function getMenuManager(): IMenuManager | undefined {
    return (AppServiceProvider.getInstance()
        .getAppServices() as IEditorAppServices).editableServiceLayer?.menuManager;
}

